export const aboutBMHomes = {
  title: "About BM Homes",
  description: [
    "BM Homes is a Chennai-based construction firm established in January 2016, delivering reliable, well-planned, and thoughtfully executed solutions across residential, commercial, and institutional projects. Since our inception, we have been committed to creating buildings that balance functionality, durability, and design while meeting the practical needs of our clients.",
  ],
  readMoreLink: "/aboutus",
};

export const aboutPageData = {
  intro: {
    heading: "About BM Homes",
    description: `BM Homes is a Chennai-based construction firm established in January 2016, delivering reliable, well-planned, and thoughtfully executed solutions across residential, commercial, and institutional projects. Since our inception, we have been committed to creating buildings that balance functionality, durability, and design while meeting the practical needs of our clients.`,
  },

  philosophy: {
    heading: "Building Spaces. Creating Trust.",
    description: `This tagline reflects the core of our work philosophy. We believe that every successful project begins with a clear understanding of requirements, careful planning, and transparent communication. Trust is built through consistent quality, responsible execution, and adherence to timelines.`,
  },

  services: {
    description: `BM Homes offers comprehensive end-to-end services, including building construction, interior design, renovations, and 3D visualization. Our integrated service model allows us to manage projects seamlessly from concept and design development through construction and final delivery. By handling all stages under one roof, we ensure better coordination, cost control, and execution clarity.`,
  },

  approach: {
    description: `Our approach emphasizes practical design solutions supported by skilled workmanship and the use of quality materials. We focus on creating spaces that are not only visually appealing but also structurally sound, efficient, and built for long-term performance. Each project is managed with attention to detail, technical precision, and professional oversight to ensure consistent outcomes.`,
  },

  commitment: {
    description: `At BM Homes, we understand that every project represents a significant investment. That is why we prioritize transparency, accountability, and client satisfaction at every stage of the construction process. Whether it is a residential home, a commercial facility, or an institutional building, we approach each project with the same level of dedication, integrity, and professionalism.`,
  },

  closing: {
    description: `Over the years, BM Homes has built a reputation for dependable construction practices and thoughtful project delivery. Our goal is to create spaces that serve their purpose effectively today while remaining durable and relevant for years to come.`,
  },

  vision: {
    heading: "Our Vision",
    text: `To be the most trusted construction partner, known for delivering high-quality spaces on time that meet client expectations and stand the test of time.`,
  },

  mission: {
    heading: "Our Mission",
    points: [
      "To deliver projects with quality, precision, and attention to detail, ensuring every space meets our high standards.",
      "To prioritize client satisfaction through transparent communication and a deep understanding of client vision.",
      "To ensure timely project completion through skilled craftsmanship and efficient project management.",
      "To embrace innovation and sustainable construction practices, creating safe and future-ready spaces.",
    ],
  },
};

export interface SocialLink {
  type: "instagram" | "facebook";
  url: string;
}

export interface FooterData {
  address: string[];
  phone: string;
  email: string;
  mapUrl: string;
  socialLinks: SocialLink[];
}

export const footerData: FooterData = {
  address: [
    "No: 138/97B, Mezzanine Floor, ",
    "Mettu Street, Tiruvottiyur, ",
    "Chennai - 600019, ",
    "Tamil Nadu, India",
  ],
  phone: "+91-7811966666 / +91-9940866693 / +91-9791166693",
  email: "info@bmhomes.in / bmhomeschennai@gmail.com",
  mapUrl:
    "https://www.google.com/maps?q=138/97%20Mettu%20Street%20Tiruvottiyur%20Chennai%20600019&output=embed",
  socialLinks: [
    { type: "instagram", url: "https://www.instagram.com/bmhomeschennai/" },
    { type: "facebook", url: "https://www.facebook.com/profile.php?id=61593608517190" },
  ],
};

export const OG_IMAGE = "https://bmhomes.in/og-image.jpg";
export const SITE_URL = "https://bmhomes.in";
